import PageTextHeading from './pageTextHeading'

export default PageTextHeading
